import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import { connectModal } from '../../../features/modal/hoc';
import { apiCallIds } from '../api';
import Select from 'antd/lib/select';


const { Option } = Select;
@translate()
@connectModal(apiCallIds.ACCEPT_LOAN)
export default class AcceptLoanModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  changedDrop = (val) => {
    this.setState({ valueDrop: val });
  }

  handleAcceptModalConfirm = () => {
    this.props.onSubmit();
  };

  render() {
    const { modalActions, isLoading, isVisible, t, children } = this.props;

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        <Modal
          title={t('Naozaj si prajete schváliť pôžičku?')}
          visible={isVisible}
          confirmLoading={isLoading}
          onOk={this.handleAcceptModalConfirm}
          onCancel={modalActions.hide}
          okText={t('Schváliť')}
        >
          {t(
            'Pre schválenie pôžičky stlačte tlačidlo schváliť.'
          )}
        </Modal>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/AcceptLoanModal.js